import { useCallback, useEffect, useState } from "react";

import { MachineIconSetting } from "@/sx-layout/models";

type IconSetting = {
  machine_icon_id: number;
  icon_color: string;
};

export const useMachineIconSetting = (machineIcons: MachineIconSetting[]) => {
  const [values, setValues] = useState<IconSetting[]>([]);

  useEffect(() => {
    setValues(machineIcons.map((v) => ({ machine_icon_id: v.machine_icon_id, icon_color: v.icon_color })));
  }, [machineIcons]);

  const add = useCallback(
    ({ id, color }: { id: number; color: string }) => {
      const index = values?.findIndex((v) => v.machine_icon_id === id);
      const item = { machine_icon_id: id, icon_color: color };
      if (0 <= index) {
        const updated = [...values];
        updated.splice(index, 1, item);
        setValues(updated);
      } else {
        setValues([...values, item]);
      }
    },
    [values, setValues]
  );

  const remove = useCallback(
    (id: number) => {
      const index = values.findIndex((v) => v.machine_icon_id === id);
      if (0 <= index) {
        const removed = [...values];
        removed.splice(index, 1);
        setValues(removed);
      }
    },
    [values, setValues]
  );

  return {
    values,
    add,
    remove,
  };
};
